const BaseUrl = 'https://quizzes-tz5s.onrender.com';
export default BaseUrl;